import React, {useState} from 'react';
import {IDocumentCardView, IFile} from "./types/document-card.types";
import {Dropdown, Input, message, Modal, Popconfirm} from "antd";
import {
    BellOutlined,
    CheckOutlined,
    DeleteOutlined,
    DownloadOutlined,
    EllipsisOutlined,
    EyeOutlined,
    StopOutlined
} from "@ant-design/icons";
import Locale from "../../../core/locale/locale";
import dayjs from "dayjs";
import {IDocument} from "../document-uploader/type/document.types";
import DocumentPreview from "../document-uploader/document-preview";
import server from "../../../server";

const DocumentCardView: React.FC<IDocumentCardView> = ({file, handleNotifyPolicy, showNotify, showPublished, handleDownload, handleUnpublishPolicy, handlePublishPolicy, showUnpublished, handleDelete, showDelete, isAdmin}) => {

    const [showPreview, setShowPreview] = useState<boolean>(false);
    const [showUnpublishModal, setShowUnpublishModal] = useState(false);
    const [reason, setReason] = useState("");

    const handleOnPublishPolicy = () => {
        try {
            if (handlePublishPolicy) {
                handlePublishPolicy(file.id)
            }
        } catch (e) {
            console.log("Error while publishing policy", e)
        }
    }

    const notifyPolicy = () => {
        try {
            if (handleNotifyPolicy) {
                handleNotifyPolicy(file.id)
            }
        } catch (e) {
            console.log("Error while notifying policy!")
        }
    }

    const menuItems = [
            {label: "Download", key: "download", icon: <DownloadOutlined/>},
            {label: "View", key: "view", icon: <EyeOutlined/>},
            ...(isAdmin && showPublished && (file.status === "DRAFT" || file.status === "UN_PUBLISHED")
                    ? [
                        {
                            key: "published",
                            danger: false,
                            icon: <CheckOutlined/>,
                            label: (
                                <span onClick={handleOnPublishPolicy}>
                            Publish</span>
                            ),
                        },
                    ]
                    : []
            ),
            ...(isAdmin && showNotify && file.status === "PUBLISHED"
                    ? [
                        {
                            key: "notify",
                            danger: false,
                            icon: <BellOutlined/>,
                            label: (
                                <span onClick={notifyPolicy}>
                            Notify</span>
                            ),
                        },
                    ]
                    : []
            ),
            ...(isAdmin && showUnpublished && file.status !== "UN_PUBLISHED" && file.status !== "DRAFT"
                ? [
                    {
                        key: "unpublished",
                        danger: true,
                        icon: <StopOutlined/>,
                        label: (
                            <span
                                onClick={() => {
                                    setShowUnpublishModal(true);
                                }}>
                            Unpublish</span>
                        ),
                    },
                ]
                : []),
            ...(isAdmin && showDelete || file.status === "UN_PUBLISHED" || file.status === "DRAFT"
                ? [
                    {
                        key: "delete",
                        danger: true,
                        icon: <DeleteOutlined/>,
                        label: (
                            <Popconfirm
                                title="Delete document"
                                description="Are you sure you want to delete this document?"
                                okText="Yes"
                                cancelText="Cancel"
                                onConfirm={() => handleDelete(file.id)}
                            >
                                <span>Delete</span>
                            </Popconfirm>
                        ),
                    },
                ]
                : []),
        ]
    ;

    const menuProps = {
        items: menuItems,
        onClick: ({key}: { key: string }) => {
            if (key === "download") {
                handleDownload(file.id);
            }
            if (key === "view") {
                setShowPreview(true)
            }
            //
            // if (key === "delete") {
            //     handleDelete(file.id);
            // }
        },
    };

    function mapFileToPreviewDoc(file: IFile): IDocument {
        return {
            id: file.orgDocumentId,
            name: file.name,
            contentType: file.contentType
        }
    }

    const previewDoc = mapFileToPreviewDoc(file);

    const documentDate = file.date ? dayjs(file.date).format(Locale.displayDateWithMonth) : ""

    return (
        <>
            <div
                className="document-card"
                onClick={() => setShowPreview(true)}
            >

                <img
                    className="document-card__thumbnail"
                    src={file.fileCoverUrl}
                    alt={file.name}
                />

                <div className="document-card__info">
                    <h4 className="document-card__title">{file.name}</h4>
                    <p className="document-card__date-size">
                        <span className={'date'}>{documentDate}</span>
                        <span className={'size'}>{file.size}</span>
                    </p>
                </div>

                <div
                    className="document-card__actions"
                    onClick={(e) => e.stopPropagation()}
                >
                    <Dropdown
                        className="document-card__dropdown"
                        trigger={["click"]}
                        menu={menuProps}
                    >
                        <EllipsisOutlined className="document-card__menu-icon"/>
                    </Dropdown>
                </div>

                {file.description && <div className="document-card__overlay">
                    <h4 className="document-card__overlay-title">Description</h4>
                    <p className="document-card__overlay-text">
                        {file.description || "No description provided"}
                    </p>
                </div>}
            </div>

            <Modal
                title="Unpublish Document"
                open={showUnpublishModal}
                okText="Unpublish"
                cancelText="Cancel"
                onCancel={() => {
                    setShowUnpublishModal(false);
                    setReason("");
                }}
                onOk={async () => {
                    if (handleUnpublishPolicy) {
                        await handleUnpublishPolicy(
                            file.id,
                            "UN_PUBLISHED",
                            reason
                        );
                        setShowUnpublishModal(false);
                        setReason("");
                    }
                }}
            >
                <p>Are you sure you want to unpublish this document?</p>

                <Input.TextArea
                    placeholder="Enter reason for unpublishing"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                />
            </Modal>

            {showPreview && (
                <DocumentPreview
                    document={previewDoc}
                    showPreview={showPreview}
                    closePreview={() => setShowPreview(false)}
                />
            )}
        </>
    )


}

export default DocumentCardView;
